import React, { useEffect, useState } from 'react';
// import Slider from "../../ui/slider/slider";
import { Button, Col, Row } from 'antd';
import { useNavigate } from 'react-router-dom';
import imagenFondo from '../../../assets/images/aroundTheWeb/12.png'
import { Slider2 } from '../../ui/slider/slider2';
import './homeSection.css'
import axios from 'axios';
import { getPriceListURL } from '../../../services/utils';
import moment from 'moment';
import credentials from '../../../settings';



const MobileHomeSection = ({ navigate }) => {
  const [precios, setPrecios] = useState([])
  const [tokenState, setTokenState] = useState(null);



  useEffect(() => {
    const login = async () => {
      const url = process.env.REACT_APP_API_URL + "/login";
      await axios
        .post(url, credentials)
        .then((response) => {
          let token = response.data.data.token;
          setTokenState(token);
          guardarToken(token);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    login();
  }, []);


  const guardarToken = (token) => {
    try {
      localStorage.setItem("token", token);
    } catch (e) {
      console.log(e);
    }
  };



  useEffect(() => {
    const fechaActual = moment().format("YYYY-MM-DD[T]HH:mm:ss");
    if (tokenState) { setDataToTickets(fechaActual, tokenState); }
  }, [tokenState]);

  const setDataToTickets = async (fechaActual, token) => {
    const prices = await getPrices(fechaActual, token);
    // Filtrar solo los que tengan priceid 140, 88 o 89
    const filteredPrices = prices.filter(price =>
      [140, 89, 88].includes(price.priceId)
    );

    setPrecios(filteredPrices);
  };
  const getPrices = async (fechaActual, token) => {
    const config = {
      headers: { Authorization: "Bearer " + token },
    };
    return await axios
      .get(getPriceListURL(fechaActual), config)
      .then((response) => {
        return response.data.data;
      })
      .catch((e) => {
        console.log(e);
        return [];
      });
  };

  return (
    <>
      <Row justify={'center'} align={'middle'}>
        <Col xs={22} sm={22} md={0} lg={0} xl={0} >
          <section className="home-card">
            <h1>Vení a conocer el Museo!</h1>
            <p>Adquirí tu entrada en forma on-line desde cualquier lugar con tarjeta de crédito o débito hasta una hora antes del comienzo de cada turno.</p>
            {precios.length > 0 && <div>
              <h4><b>Precios</b></h4>
              <ul>
                {precios
                  .sort((a, b) => {
                    const order = [140, 89, 88]; // Orden deseado: Menor 2-12, Menor 13-17, Adulto 18+
                    return order.indexOf(a.priceId) - order.indexOf(b.priceId);
                  })
                  .map(({ name, amount, priceId }) => (
                    <li key={priceId}>
                      <b>{name.replace(/^\d{2} - /, "")}:</b> ${amount.toLocaleString("es-ES")}
                    </li>
                  ))}
              </ul>
            </div>}
            <Button
              className='btn'
              type="primary"
              style={{ background: "#FF8165", width: '30%' }}
              onClick={() => navigate(`/comprar`)}
            >
              Comprar
            </Button>
          </section>
        </Col>
      </Row>
      <Row justify={'center'} align={'middle'}>
        <Col xs={22} sm={22} md={0} lg={0} xl={0}>
          <section className='home-slider-container-mobile'>
            <Slider2 />
          </section>
        </Col>
      </Row>
    </>
  )
}

const DesktopHomeSection = ({ navigate }) => {
  const [precios, setPrecios] = useState([])
  const [tokenState, setTokenState] = useState(null);



  useEffect(() => {
    const login = async () => {
      const url = process.env.REACT_APP_API_URL + "/login";
      await axios
        .post(url, credentials)
        .then((response) => {
          let token = response.data.data.token;
          setTokenState(token);
          guardarToken(token);
        })
        .catch((e) => {
          console.log(e);
        });
    };

    login();
  }, []);


  const guardarToken = (token) => {
    try {
      localStorage.setItem("token", token);
    } catch (e) {
      console.log(e);
    }
  };


  useEffect(() => {
    const fechaActual = moment().format("YYYY-MM-DD[T]HH:mm:ss");
    if (tokenState) { setDataToTickets(fechaActual, tokenState); }
  }, [tokenState]);

  const setDataToTickets = async (fechaActual, token) => {
    const prices = await getPrices(fechaActual, token);
    // Filtrar solo los que tengan priceid 140, 88 o 89
    const filteredPrices = prices.filter(price =>
      [140, 89, 88].includes(price.priceId)
    );

    setPrecios(filteredPrices);
  };
  const getPrices = async (fechaActual, token) => {
    const config = {
      headers: { Authorization: "Bearer " + token },
    };
    return await axios
      .get(getPriceListURL(fechaActual), config)
      .then((response) => {
        return response.data.data;
      })
      .catch((e) => {
        console.log(e);
        return [];
      });
  };
  return (
    <Row justify={'space-between'} align={'middle'}>
      <Col xs={0} sm={0} md={13} lg={11} xl={11} style={{ position: 'relative', margin: '5rem 0' }}>
        <section className="home-card">
          <h1>¡Vení a conocer el Museo!</h1>
          <p>Adquirí tu entrada en forma on-line desde cualquier lugar con tarjeta de crédito o débito hasta una hora antes del comienzo de cada turno.</p>
          {precios.length > 0 && <div>
            <h5><b>Precios</b></h5>
            <ul>
              {precios
                .sort((a, b) => {
                  const order = [140, 89, 88]; // Orden deseado: Menor 2-12, Menor 13-17, Adulto 18+
                  return order.indexOf(a.priceId) - order.indexOf(b.priceId);
                })
                .map(({ name, amount, priceId }) => (
                  <li key={priceId}>
                    <b>{name.replace(/^\d{2} - /, "")}:</b> ${amount.toLocaleString("es-ES")}
                  </li>
                ))}
            </ul>
          </div>}
          <Button
            type="primary"
            style={{ background: "#FF8165", width: '30%' }}
            onClick={() => navigate(`/comprar`)}
          >
            Comprar
          </Button>
        </section>
        <img className='img-fondo' src={imagenFondo} alt="imagenFondo" />
      </Col>
      <Col xs={0} sm={0} md={10} lg={12} xl={12} style={{ margin: '5rem 0' }}>
        <Slider2 />
      </Col>
    </Row>
  )
}

const HomeSection = () => {
  const navigate = useNavigate();

  return (
    <div className='homesection-container'>
      <MobileHomeSection navigate={navigate} />
      <DesktopHomeSection navigate={navigate} />
    </div>
  );
};

export default HomeSection;
